import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { FaseService } from '../../_services/fase.service';
import { Fase } from '../../_models/fase';
import { forkJoin } from 'rxjs';
import { FaseEstadoService } from '../../_services/fase-estado.service';
import { FaseEstadoRolService } from '../../_services/fase-estado-rol.service';
import { FaseEstado } from '../../_models/fase-estado';
import { FaseEstadoRol } from '../../_models/fase-estado-rol';
import { NavService } from '../../_services/_nav.service';
import { Location } from '@angular/common';

@Component( {
  selector: 'app-fase-detalle',
  templateUrl: 'fase-detalle.component.html'
} )

export class FaseDetalleComponent implements OnInit {

  carInformacionInicial = true;
  fase: Fase;
  lisFaseEstado: FaseEstado[] = [];
  columnas: any[] = [];

  constructor( private fasServicio: FaseService,
               private fasEstadoServicio: FaseEstadoService,
               private fasEstadoRolServicio: FaseEstadoRolService,
               private location: Location,
               private navServicio: NavService,
               private route: ActivatedRoute ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'fase', header: this.navServicio.buscarMensaje( 'FASES.LBL_FASE' ), sort: true },
      { field: 'estado', header: this.navServicio.buscarMensaje( 'FASES.LBL_ESTADO' ), sort: true },
      { field: 'roles', header: this.navServicio.buscarMensaje( 'FASES.LBL_ROLES' ), sort: false },
    ];

    this.route.params.subscribe( ( params: Params ) => {
      forkJoin( this.fasServicio.obtenerPorId( params[ 'id' ] ),
        this.fasEstadoServicio.listadoPorFase( params[ 'id' ] ),
        this.fasEstadoRolServicio.listadoPorFase( params[ 'id' ] ) ).subscribe( ( [ fase, lisEstados, lisRoles ] ) => {
        this.fase = fase;
        lisEstados.map( ( s: FaseEstado ) => {
          if ( s.indicadorHabilitado ) {
            let roles = '';
            lisRoles.map( ( x: FaseEstadoRol ) => {
              if ( x.indicadorHabilitado && x.idFaseEstado === s.idFaseEstado ) {
                roles += (roles ? (',' + x.rol) : x.rol);
              }
            } );
            s.roles = roles;
            this.lisFaseEstado.push( s );
          }
        } );
        this.carInformacionInicial = false;
      } );
    } );
  }

  regresar() {
    this.location.back();
  }
}
